enum RouteName {
    LOGIN = 'Login',
    HOME = 'Home',
    USERS_DETAILS = 'UsersDetails',
    USER_DETAILS = 'UserDetails'
}

export { RouteName };
